import React, { useRef, useEffect, useState } from 'react';
import { FiChevronRight } from 'react-icons/fi';

const TabNavigation = ({ tabs, activeTab, onTabChange }) => {
  const scrollContainerRef = useRef(null);
  const [showScrollIndicator, setShowScrollIndicator] = useState(false);

  // Check if scrolling is needed when component mounts or window resizes
  useEffect(() => {
    const checkForOverflow = () => {
      if (scrollContainerRef.current) {
        const { scrollWidth, clientWidth } = scrollContainerRef.current;
        setShowScrollIndicator(scrollWidth > clientWidth);
      }
    };

    // Check on initial render
    checkForOverflow();
    
    // Check on window resize
    window.addEventListener('resize', checkForOverflow);
    return () => window.removeEventListener('resize', checkForOverflow);
  }, []);

  return (
    <div className="mb-6 border-b border-gray-200 relative">
      <div 
        ref={scrollContainerRef}
        className="flex -mb-px space-x-1 overflow-x-auto scrollbar-hide scroll-smooth"
        style={{ 
          WebkitOverflowScrolling: 'touch', // Enable momentum scrolling on iOS
          scrollbarWidth: 'none',  // Hide scrollbar in Firefox
          msOverflowStyle: 'none'  // Hide scrollbar in IE/Edge
        }}
      >
        {tabs.map((tab) => (
          <button
            key={tab.id}
            onClick={() => onTabChange(tab.id)}
            className={`whitespace-nowrap py-3 px-4 font-medium text-sm border-b-2 transition-colors cursor-pointer 
              ${activeTab === tab.id 
                ? 'border-blue-600 text-blue-600' 
                : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}
          >
            {tab.label}
          </button>
        ))}
      </div>
      
      {/* Scroll indicator that appears when tabs overflow */}
      {showScrollIndicator && (
        <div className="absolute right-0 top-0 h-full flex items-center pointer-events-none">
          <div className="bg-gradient-to-l from-slate-50 to-transparent w-12 h-full flex items-center justify-end pr-1">
            <div className="animate-pulse bg-blue-100 rounded-full p-1 shadow-sm">
              <FiChevronRight className="text-blue-600 text-lg" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TabNavigation;